<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-info">
          <h3>广州沃仕顿机械设备有限公司</h3>
          <p>Guangzhou VOSDOM Machinery Equipment Co.,Ltd.</p>
        </div>
        <div class="footer-links">
          <div class="link-group">
            <h4>联系方式</h4>
            <ul>
              <li>邮箱: service@vosdom.com</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <p>© {{ currentYear }} 广州沃仕顿机械设备有限公司 版权所有</p>
        <p>粤ICP备19023550号-1 公安备案号：44011302002011</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer {
  background: #eeecec;
  color: rgb(43, 42, 42);
  padding: 50px 0 20px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.footer-info h3 {
  margin-bottom: 20px;
  font-size: 1.5rem;
}

.footer-info p {
  opacity: 0.8;
}

.footer-links {
  display: flex;
  text-align: center;
  gap: 150px;
}

.link-group h4 {
  margin-bottom: 20px 20px;
  font-size: 1.2rem;
}

.link-group ul {
  list-style: none;
  padding: 0;
}

.link-group li {
  margin-bottom: 10px;
}

.link-group a {
  color: #ccc;
  text-decoration: none;
  transition: color 0.3s;
}

.link-group a:hover {
  color: white;
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #555;
  opacity: 0.8;
  font-size: 0.9rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 30px;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 20px;
  }
}
</style>